/* Forged Racing — keep the Shopify Inbox launcher off the checkout button.

   ROUND 26 (D6). Round 19 fixed this for the cart DRAWER with
   `body.forged-scroll-lock shopify-chat { display:none !important }`. That
   hook is the theme's own scroll lock, which the /cart PAGE never sets — so
   on the page the launcher sat on the CHECK OUT button again. Hit-tested at
   390x844, scrollY 0, 1-item cart: 7 of 9 points across the button returned
   the button, but x=315 and x=355 returned SHOPIFY-CHAT.

   WHY NOT BOTTOM PADDING. The obvious fix is to pad the action area so the
   button clears the corner, but that cannot work here. The launcher is
   position:fixed, so its viewport rect is independent of scroll; the measured
   collision happens at scrollY 0, where the button's viewport position is set
   by the content ABOVE it. Padding BELOW the button does not move it in the
   default view, and at some scroll offset the button will always pass through
   the fixed corner anyway. The only condition that actually predicts the
   collision is the one tested here: does the button currently intersect the
   launcher's painted footprint.

   WHY HIT-TEST RATHER THAN getBoundingClientRect. The launcher is inside a
   shadow root with no ::part() exposed, and the HOST element reports the full
   viewport (measured: 0,0 390x844) — so the host's rect says nothing about
   where the button actually is. Scanning elementFromPoint over the
   bottom-right corner yields the real painted footprint (measured: x 285-369,
   y 711-755, ~88x48, 21px from the right edge).

   Measured at RUNTIME, never hardcoded, deliberately: in the Shopify theme
   preview the dev bar occupies the bottom ~68px and pushes the launcher up,
   so any constant derived in dev would be wrong in production. Measuring in
   the visitor's own browser adapts to that, to Inbox layout changes, and to
   the launcher's expanded/collapsed states.

   The scan is O(region) so it runs on load and resize ONLY — the launcher is
   fixed, so scrolling cannot move it. Scroll only re-tests the cheap
   rectangle intersection (see the note on onScroll for why that is not
   rAF-throttled). */
(function () {
  'use strict';

  var CLASS = 'forged-chat-dodge';
  var PAD = 8;              /* safety margin around the measured footprint */
  var STEP = 5;             /* scan resolution; launcher is ~88x48 so this can't miss it */
  var rect = null;          /* cached launcher footprint, viewport coords */

  function checkoutButton() {
    var btns = document.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    for (var i = 0; i < btns.length; i++) {
      var r = btns[i].getBoundingClientRect();
      if (r.width > 40 && r.height > 20) return btns[i];
    }
    return null;
  }

  /* ROUND 41 — second protected target: the footer payment row.

     Enlarging the launcher (85x46 -> 108x61 painted) made an existing overlap
     worse rather than creating one: measured at 414 with the footer in view,
     Inbox's own default already covered 1 of the 10 payment icons and the new
     size covered 3. The brief was to fix the dodge rather than give the size
     back, so this file now protects two things instead of one.

     The pay ROW is used as the target, not each icon. Icons are ~30px wide, so
     per-icon testing would hide the launcher only once it had already eaten
     most of one; the row is the thing that has to stay readable.

     Policy links were measured as never covered at any tested width (0 of 5),
     so they are not tracked — a target that cannot collide would just be a
     rectangle read on every beat forever. */
  function payRow() {
    var el = document.querySelector('.frg-footer__pay');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    return (r.width > 0 && r.height > 0) ? el : null;
  }

  /* Derive the launcher's painted footprint by hit-testing the corner.
     Returns null while the app hasn't booted or while we're mid-dodge
     (display:none makes it unhittable, which would poison the cache). */
  function measure() {
    if (document.body.classList.contains(CLASS)) return;
    if (!document.querySelector('shopify-chat')) return;

    var W = window.innerWidth, H = window.innerHeight;
    var minX = W, minY = H, maxX = -1, maxY = -1;
    for (var x = W - 2; x > W - 220 && x > 0; x -= STEP) {
      for (var y = H - 2; y > H - 240 && y > 0; y -= STEP) {
        var el = document.elementFromPoint(x, y);
        if (el && el.tagName === 'SHOPIFY-CHAT') {
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return;
    rect = { left: minX - PAD, top: minY - PAD, right: maxX + PAD, bottom: maxY + PAD };
  }

  function update() {
    /* Fail OPEN, never closed. If we have no footprint the launcher must be
       left alone — a stuck class here means chat is permanently dead on the
       cart page, which is a worse bug than the one this file fixes. */
    if (!rect) {
      document.body.classList.remove(CLASS);
      return;
    }
    /* ROUND 41: two targets now. Still fails OPEN — if neither is present the
       launcher is left alone, for the same reason as before: a stuck class here
       means chat is permanently dead, which is worse than the overlap. */
    var targets = [];
    var btn = checkoutButton();
    if (btn) targets.push(btn);
    var pay = payRow();
    if (pay) targets.push(pay);

    if (!targets.length) {
      document.body.classList.remove(CLASS);
      return;
    }

    var hits = false;
    for (var i = 0; i < targets.length; i++) {
      var b = targets[i].getBoundingClientRect();
      if (b.width <= 0 || b.height <= 0) continue;   /* offscreen / display:none */
      if (!(b.right < rect.left || b.left > rect.right ||
            b.bottom < rect.top || b.top > rect.bottom)) { hits = true; break; }
    }

    /* Chat stays reachable everywhere except the moment it would eat a tap
       meant for CHECK OUT, or sit on top of the payment icons — the launcher
       returns as soon as they separate. */
    document.body.classList.toggle(CLASS, hits);
  }

  function onScroll() {
    update();
  }

  /* One self-healing step: measure if we don't have a footprint, then apply.
     `rect` goes null at load (app not booted yet) and again on every resize,
     and an earlier version tried to re-measure with a single one-shot timer
     after resize. When that one attempt missed, `rect` stayed null forever,
     update() failed open, and the dodge was silently dead for the rest of the
     page life. Caught live: at 320 with the button deliberately parked on the
     launcher, 3 of 9 points still returned SHOPIFY-CHAT. Re-measuring from
     the poll means a missed attempt costs 300ms, not the session. */
  function tick() {
    if (!rect) measure();
    update();
  }

  function boot() {
    /* ROUND 41: was `if (!checkoutButton()) return`, which meant this file did
       nothing on every page without a cart — including the homepage, where the
       footer payment row it now also protects lives. Boots if EITHER target
       exists. The footer is on essentially every page, so in practice this now
       runs site-wide; update() is two rect reads and a compare, which is why
       that is affordable. */
    if (!checkoutButton() && !payRow()) return;   /* nothing to protect here */

    /* WHY A POLL AND NOT JUST THE SCROLL EVENT.
       Two mechanisms were tried here and BOTH failed silently in live
       verification, which is exactly the failure mode this build keeps
       producing — the fix looks right and does nothing:

         1. rAF-throttled scroll. requestAnimationFrame never fired, so the
            `ticking` guard latched true on the first scroll and update() was
            never called again.
         2. Un-throttled scroll. A control listener added alongside it counted
            ZERO scroll events on `window` while scrollY demonstrably moved
            0 -> 300, so the handler never ran at all.

       Either way the class stuck on and chat was permanently hidden on /cart
       — worse than the overlap this file exists to fix.

       setInterval is the one scheduling mechanism verified to work in that
       environment (the boot measurement below runs on it). The scroll
       listener is kept because where it does fire it responds instantly; the
       poll is the guarantee that the class can never latch. update() is two
       getBoundingClientRect reads and a rect compare, so 300ms costs nothing,
       and it only runs on pages that actually have a checkout button. */
    window.addEventListener('scroll', onScroll, { passive: true });
    setInterval(tick, 300);

    /* Drop the cached footprint; tick() re-measures on the next beat. The
       class is cleared too so measure() can actually see the launcher — it is
       display:none while dodging, hence unhittable. */
    window.addEventListener('resize', function () {
      document.body.classList.remove(CLASS);
      rect = null;
    });

    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
